// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__bDZEL","productName":"Table_productName__3_-MQ"};